import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getConsistencyCheckBranchExport } from '@api/consistencyCheck';

import { TConsistencyCheckBranchExportDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { ESnackbarTypes } from '@enums/common';

import { CONSISTENCY_BRANCH_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

const useMutateConsistencyCheckBranchExport = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handleConsistencyCheckBranchExport,
		isLoading: isLoadingConsistencyCheckBranchExport,
	} = useMutation<TConsistencyCheckBranchExportDTO>({
		mutationKey: [CONSISTENCY_BRANCH_EXPORT],
		mutationFn: getConsistencyCheckBranchExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		handleConsistencyCheckBranchExport,
		isLoadingConsistencyCheckBranchExport,
	};
};

export default useMutateConsistencyCheckBranchExport;
